import styled from 'styled-components/macro';
import { WxLabel, WxText } from '../..';
import { useAddressContext } from '../../../hooks/context/useAddressContext';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';
import { StringInput } from './StringInput';

export const AddressForm = ({ isNotDemat }: any) => {
  const { address, setAddress, dataAddr, placeId, setPlaceId, errors } =
    useAddressContext();

  return (
    <Wrapper>
      <header>
        <WxLabel label={__('Other address')} active />
        {placeId ? (
          <WxText text={__('Please complete required fields')} darkMode />
        ) : (
          <WxText text={__('Search an address')} darkMode />
        )}
      </header>
      <Form autoComplete="off">
        {isNotDemat && (
          <>
            <StringInput
              placeholder={__('Address')}
              required={true}
              setPlaceId={setPlaceId}
              data={dataAddr}
              setValue={(s: string) => setAddress({ ...address, address1: s })}
              value={address.address1}
              errors={errors.address1}
            />
            {placeId && (
              <>
                <StringInput
                  placeholder={__('Address details')}
                  setValue={(s: string) =>
                    setAddress({ ...address, address2: s })
                  }
                  value={address.address2}
                />
                <FieldRow>
                  <StringInput
                    placeholder={__('Postcode')}
                    required={true}
                    setPlaceId={setPlaceId}
                    setValue={(s: string) =>
                      setAddress({ ...address, zipcode: s })
                    }
                    value={address.zipcode}
                    readOnly={true}
                  />
                  <StringInput
                    placeholder={__('City')}
                    required={true}
                    setValue={(s: string) =>
                      setAddress({ ...address, city: s })
                    }
                    value={address.city}
                    readOnly={true}
                  />
                </FieldRow>
              </>
            )}
          </>
        )}
      </Form>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-bottom: 2.8rem;
  header {
    > :first-child {
      margin-bottom: 1.25rem;

      @media (min-width: ${breakpoint}) {
        margin-bottom: 2.8rem;
      }
    }
    margin-bottom: 1.25rem;
  }
`;

const Form = styled.form`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  background: none;
  overflow: hidden;
  gap: 0.625rem;
  min-height: 200px;

  @media (min-width: 30rem) {
    flex-direction: column;
    gap: 1.25rem;
    max-width: 46rem;
    > * {
      width: calc(50% - 1.25rem / 2);
      box-sizing: border-box;
      position: relative;
      padding-inline: 1rem;
    }
  }
`;

const FieldRow = styled.div`
  display: flex;
  gap: 20px;
`;
